import * as RefundRulesService from '../../services/refundRules/RefundRulesService';

export function execute(departureFlight, returnFlight, passengers) {
  return new Promise((resolve, reject) => {
    RefundRulesService.getRefundRules(departureFlight, returnFlight, passengers)
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        resolve({
          error: err
        });
      });
  });
}



// WEBPACK FOOTER //
// ./src/usecases/refundRules/RefundRulesUC.js